import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import {useCartContext} from '../../Context/CartContext'
import styles from './DiscountProgressBar.module.css'

export const DiscountProgressBar = () => {
    const [isLoad, setIsLoad] = useState(false);

    const {cart, getCart} = useCartContext();

    const [currentValue, setCurrentValue] = useState(0)
    const [discountCondition, setDiscountCondition] = useState(0)
    const [discountPersent, setDiscountPersent] = useState(0);

    useEffect(() => {
        const cart = JSON.parse(getCart());

        setDiscountCondition(cart.DiscountModel.DiscountCondition);
        setDiscountPersent(cart.DiscountModel.DiscountPercent);
        setCurrentValue(cart.CurrentLitersToDiscount);
        setIsLoad(true)
    }, [cart])

    const calculatePercentage = () => {
        console.log("calculatePercentage start.")

        if(currentValue >= 0 && discountCondition)
        {
            const result = (currentValue / discountCondition) * 100;
            if(result > 100){
                return 100;
            }
            //для нормального отображения надписи в прогресс баре (если меньше 20%, то не видно цель и текущее)
            else if(result < 20){
                return 20
            }
            return result
        }
        else{
            return 0;
        }
        
    };

    const valueTemplate = () => {
        if(currentValue >= discountCondition){
            return (
                <React.Fragment>
                    Ціль досягнуто!!! :)
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                {currentValue}л / {discountCondition}л
            </React.Fragment>
        );
    };

    return (
        <div className={styles.wrapper} >
            {isLoad && currentValue > 0 ?
            <div>
                <span>Ціль для отримання знижки по продуктам, позначеним символом "-{discountPersent}%"</span>
                <div className={`card`} style={{margin:'3px'}}>
                    <ProgressBar value={calculatePercentage()} displayValueTemplate={valueTemplate}></ProgressBar>
                </div>
            </div> : null}
        </div>
        
    );
}